import {
  Filter,
  serializeFilter,
} from "./pages/specialty-assistant/dashboard/filter";

export const ROUTES = {
  // Logged out
  LANDING: "/",

  // Logged in
  BROKER_ANALYTICS: "/broker-analytics",
  DASHBOARD: "/dashboard",
  DASHBOARD_WITH_FILTER: (filter: Filter) =>
    `/dashboard/reports?${serializeFilter(filter)}`,
  DASHBOARD_CASUALTY: "/dashboard/reports/casualty",
  DASHBOARD_ANALYTICS: "/dashboard/analytics",
  DASHBOARD_REPORT: (reportId: string | number, tabPath?: string) =>
    `/dashboard/report/${reportId}${tabPath ? "/" + tabPath : ""}`,
  DASHBOARD_SUBMISSION_HISTORY: "/dashboard/submission-history",
};
